// extracted by mini-css-extract-plugin
export default {"userTagWrapper":"index_userTagWrapper__4AyC+","iconContainer":"index_iconContainer__-aZRe","nameContainer":"index_nameContainer__5B-sI"};